// en-US translations for pages
export default {
  'pages.layouts.userLayout.title':
    'Yeditepe University Electronic Application System Login Portal',
  'pages.login.accountLogin.errorMessage': 'Incorrect username or password.',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.forgotPassword': 'Forgot Password?',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please enter your password!',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.submit': 'Login',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username',
  'pages.login.username.required': 'Please enter your username!',
  'pages.login.link.register': 'Register',
  'pages.login.message.loggingin': 'Logging in...',
  'pages.register.success': 'Registration email sent!',
  'pages.register.message.registering': 'Registering...',
  'pages.register.registerAccount': 'Register Account',
  'pages.register.registerAccount.subTitle': 'You must enter your email address to register.',
  'pages.register.submit': 'Register',
  'pages.register.email.placeholder': 'Email: example@std.yeditepe.edu.tr',
  'pages.register.email.required': 'Please input your email address!',
  'pages.register.email.invalidEmail': 'Please enter a valid email address!',
  'pages.forgotPassword.success':
    'Password reset instructions have been sent to your email address!',
  'pages.forgotPassword.message.forgotPasswording': 'Sending password reset instructions...',
  'pages.forgotPassword.title': 'Forgot Password',
  'pages.forgotPassword.subTitle': 'Enter your email to reset your password.',
  'pages.forgotPassword.submit': 'Reset Password',
  'pages.forgotPassword.email.placeholder': 'Email: example@std.yeditepe.edu.tr',
  'pages.forgotPassword.email.required': 'Please input your email address!',
  'pages.forgotPassword.email.invalidEmail': 'Please enter a valid email address!',
  'pages.changePassword.title': 'Change Password',
  'pages.changePassword.subTitle': 'Please enter your new password.',
  'pages.changePassword.submit': 'Submit',
  'pages.changePassword.newPassword.placeholder': 'New Password',
  'pages.changePassword.newPassword.required': 'New password is required.',
  'pages.changePassword.newPassword.minLength': 'New password must be at least 8 characters long.',
  'pages.changePassword.newPassword.maxLength': 'New password must be at most 20 characters long.',
  'pages.changePassword.newPassword.uppercase':
    'New password must contain at least one uppercase letter.',
  'pages.changePassword.newPassword.lowercase':
    'New password must contain at least one lowercase letter.',
  'pages.changePassword.newPassword.number': 'New password must contain at least one number.',
  'pages.changePassword.newPassword.specialChar':
    'New password must contain at least one special character.',
  'pages.changePassword.confirmPassword.placeholder': 'Confirm New Password',
  'pages.changePassword.confirmPassword.required': 'Please confirm your password!',
  'pages.changePassword.confirmPassword.mismatch': 'Passwords do not match!',
  'pages.apply.applyCard.header.title': 'Apply for a program',
  'pages.apply.applyCard.header.subTitle':
    'Providing complete and accurate information in the Pre-Application Form will have a positive impact on the evaluation of your application to the program you wish to apply for. The information provided will be kept confidential and will not be shared with third parties.',
  'pages.apply.applyCard.yos.title': "International Undergraduate",
  'pages.apply.applyCard.yos.desc': 'For International Applicants',
  'pages.apply.applyCard.graduate.title': "Master's Degree",
  'pages.apply.applyCard.graduate.desc': 'For Turkish Citizens and Foreign International Students',
  'pages.apply.applyCard.title': 'Apply Now',
  'pages.apply.applicationsTable.creationDate': 'Application Date',
  'pages.apply.applicationsTable.academicSeasonTR': 'Academic Season',
  'pages.apply.applicationsTable.applicationTypeId': 'Application Type',
  'pages.apply.applicationsTable.applicationStatus': 'Application Status',
  'pages.apply.applicationsTable.actions': 'Actions',
  'pages.apply.applicationsTable.details': 'Details',
  'pages.apply.applicationsTable.edit': 'Edit',
  'pages.apply.applicationsTable.headerTitle': 'My Applications',
  'pages.apply.applicationDetails.id': 'Application ID',
  'pages.apply.applicationDetails.descriptions.title': 'Application Details',
  'pages.apply.applicationDetails.descriptions.creationDate': 'Creation Date',
  'pages.apply.applicationDetails.descriptions.departmentPreference': 'Department Preference',
  'pages.apply.applicationDetails.descriptions.majorScience': 'Major Science',
  'pages.apply.applicationDetails.descriptions.departmentPreference2':
    'Second Department Preference',
  'pages.apply.applicationDetails.descriptions.departmentPreference3':
    'Third Department Preference',
  'pages.apply.applicationDetails.descriptions.applicationStatus': 'Application Status',
  'pages.apply.applicationsTable.applicationType.internationalMasterDegree':
    "International Undergraduate",
  'pages.apply.applicationsTable.applicationType.masterDegree': "Master's Degree",
  'pages.apply.applicationsTable.applicationType.facultyOfFineArts': 'Faculty of Fine Arts',
  'pages.apply.masterDegree.generalInformation.proCard.title': 'Identity Information',
  'pages.apply.masterDegree.generalInformation.proCard.next': 'Next',
  'pages.apply.masterDegree.generalInformation.proCard.prev': 'Previous',
  'pages.apply.masterDegree.generalInformation.nationality': 'Nationality',
  'pages.apply.masterDegree.generalInformation.nationality.placeholder':
    'Search by typing your country name.',
  'pages.apply.masterDegree.generalInformation.personName': 'First Name',
  'pages.apply.masterDegree.generalInformation.personSurname': 'Last Name',
  'pages.apply.masterDegree.generalInformation.passport': 'Passport Number',
  'pages.apply.masterDegree.generalInformation.tcNo': 'ID Number',
  'pages.apply.masterDegree.generalInformation.idNo.placeholder': 'TR ID No / Passport No',
  'pages.apply.generalInformationForm.createIdInformation.success':
    'Create Id Information successful!',
  'pages.apply.generalInformationForm.createIdInformation.loading': 'Creating Id Information...',
  'pages.apply.generalInformationForm.updateIdInformation.success':
    'Update Id Information successful!',
  'pages.apply.generalInformationForm.updateIdInformation.loading': 'Updating Id Information...',
  'pages.apply.masterDegree.generalInformation.nationalitySearch':
    'You can search and select your country using the search box above. You can search by country name or country code.',
  'pages.apply.masterDegree.generalInformation.form.submit': 'Submit',
  'pages.apply.masterDegree.generalInformation.form.reset': 'Reset',
  'pages.apply.masterDegree.generalInformation.editIdInfoButton': 'Edit Identity Information',
  'pages.apply.masterDegree.instituteApplyForm.proCard.title': 'Institute Application Form',
  'pages.apply.internationalMasterDegreeForm.proCard.title': 'Program Application Form',
  'pages.apply.masterDegree.instituteApplyForm.unit': 'Institute',
  'pages.apply.masterDegree.instituteApplyForm.unit.placeholder': 'Please select an institute.',
  'pages.apply.masterDegree.instituteApplyForm.department': 'Department',
  'pages.apply.masterDegree.instituteApplyForm.department.placeholder':
    'Please select a department.',
  'pages.apply.masterDegree.instituteApplyForm.majorScience': 'Major Science',
  'pages.apply.masterDegree.instituteApplyForm.majorScience.placeholder':
    'Please select a major science.',
  'pages.apply.masterDegree.instituteApplyForm.form.nextSubmitText': 'Next',
  'pages.apply.masterDegree.instituteApplyForm.form.prevSubmitText': 'Previous',
  'pages.apply.masterDegree.examInformation.form.submitText': 'Submit',
  'pages.apply.masterDegree.examInformation.form.resetText': 'Cancel',
  'pages.apply.masterDegree.examInformation.form.nextSubmitText': 'Next',
  'pages.apply.masterDegree.examInformation.form.prevSubmitText': 'Previous',
  'pages.apply.masterDegree.examInformation.proCard.title': 'Exam Information',
  'pages.apply.masterDegree.foreignLanguageForm.examSchema.drawerForm.update.title': 'Update Exam',
  'pages.apply.masterDegree.foreignLanguageForm.examSchema.drawerForm.create.title': 'Create Exam',
  'pages.apply.masterDegree.foreignLanguageForm.examSchema.addForeignLanguage':
    'Add Exam Information',
  'pages.apply.masterDegree.foreignLanguageForm.proCard.title': 'Foreign Language Exam Information',
  'pages.apply.masterDegree.foreignLanguageForm.proList.emptyText':
    'Your foreign language exam information is not available, please add foreign language exam information.',
  'pages.apply.masterDegree.foreignLanguageForm.proList.actions.delete.popcornfirm.title':
    'Are you sure you want to delete this exam?',
  'pages.apply.masterDegree.foreignLanguageForm.proList.actions.delete': 'Delete',
  'pages.apply.masterDegree.foreignLanguageForm.proList.actions.edit': 'Edit',
  'pages.apply.masterDegree.examSchema.createMutation.success':
    'Exam information created successfully!',
  'pages.apply.masterDegree.examSchema.createMutation.loading': 'Creating exam information...',
  'pages.apply.masterDegree.examSchema.updateMutation.success':
    'Exam information updated successfully!',
  'pages.apply.masterDegree.examSchema.updateMutation.loading': 'Updating exam information...',
  'pages.apply.masterDegree.examSchema.deleteMutation.success':
    'Exam information deleted successfully!',
  'pages.apply.masterDegree.examSchema.deleteMutation.loading': 'Deleting exam information...',
  'pages.apply.masterDegree.examInformation.centralExamTypeId.label': 'Exam Type',
  'pages.apply.masterDegree.examInformation.centralExamTypeId.placeholder': 'Select the exam type',
  'pages.apply.masterDegree.examInformation.examDate.label': 'Exam Date',
  'pages.apply.masterDegree.examInformation.examDate.placeholder': 'Select the exam date',
  'pages.apply.masterDegree.examInformation.scoreNum.label': 'Score (Total)',
  'pages.apply.masterDegree.examInformation.scoreNum.placeholder': 'Please enter your total score.',
  'pages.apply.masterDegree.examInformation.scoreVerb.label': 'Score (Written)',
  'pages.apply.masterDegree.examInformation.scoreVerb.placeholder':
    'Please enter your written score.',
  'pages.apply.masterDegree.examInformation.scoreEW.label': 'Score (Oral)',
  'pages.apply.masterDegree.examInformation.scoreEW.placeholder': 'Please enter your oral score.',
  'pages.apply.masterDegree.examInformation.totalScore.label': 'Total Score',
  'pages.apply.masterDegree.examInformation.totalScore.placeholder':
    'Please enter your total score.',
  'pages.apply.masterDegree.learningProcessForm.proCard.title': 'Education Information',
  'pages.apply.masterDegree.learningProcessForm.proList.emptyText':
    'Your education information is not available, please add education information.',
  'pages.apply.masterDegree.learningProcessForm.proList.actions.edit': 'Edit',
  'pages.apply.masterDegree.learningProcessForm.proList.actions.delete': 'Delete',
  'pages.apply.masterDegree.learningProcessForm.proList.actions.delete.popconfirm.title':
    'Are you sure you want to delete this education information?',
  'pages.apply.masterDegree.learningProcessForm.drawerForm.create.title':
    'Create Education Information',
  'pages.apply.masterDegree.learningProcessForm.drawerForm.update.title':
    'Update Education Information',
  'pages.apply.masterDegree.learningProcessForm.createMutation.success':
    'Education information created successfully!',
  'pages.apply.masterDegree.learningProcessForm.createMutation.loading':
    'Creating education information...',
  'pages.apply.masterDegree.learningProcessForm.updateMutation.success':
    'Education information updated successfully!',
  'pages.apply.masterDegree.learningProcessForm.updateMutation.loading':
    'Updating education information...',
  'pages.apply.masterDegree.learningProcessForm.deleteMutation.success':
    'Education information deleted successfully!',
  'pages.apply.masterDegree.learningProcessForm.deleteMutation.loading':
    'Deleting education information...',
  'pages.apply.masterDegree.learningProcessForm.institution.label': 'Institution',
  'pages.apply.masterDegree.learningProcessForm.institution.placeholder': 'Select Institution',
  'pages.apply.masterDegree.learningProcessForm.unit': 'Unit',
  'pages.apply.masterDegree.learningProcessForm.unit.placeholder': 'Select Unit',
  'pages.apply.masterDegree.learningProcessForm.department': 'Department',
  'pages.apply.masterDegree.learningProcessForm.department.placeholder': 'Select Department',
  'pages.apply.masterDegree.learningProcessForm.prevSubmitText': 'Previous',
  'pages.apply.masterDegree.learningProcessForm.nextSubmitText': 'Next',
  'pages.apply.masterDegree.learningProcessForm.studentLevelId.label': 'Student Level',
  'pages.apply.masterDegree.learningProcessForm.studentLevelId.placeholder': 'Select student level',
  'pages.apply.masterDegree.learningProcessForm.endAt.label': 'Graduation Date',
  'pages.apply.masterDegree.learningProcessForm.endAt.placeholder': 'Select graduation date',
  'pages.apply.masterDegree.learningProcessForm.institution.extra':
    'If the institution you are looking for is not in the list, you can type and leave its name.',
  'pages.apply.masterDegree.learningProcessForm.unit.extra':
    'If the unit you are looking for is not in the list, you can type and leave its name.',
  'pages.apply.masterDegree.learningProcessForm.department.extra':
    'If the department you are looking for is not in the list, you can type and leave its name.',
  'pages.apply.masterDegree.contactInformationForm.phoneNumber.label': 'Phone Number',
  'pages.apply.masterDegree.contactInformationForm.email.label': 'Email',
  'pages.apply.masterDegree.contactInformationForm.proCard.title': 'Contact Information',
  'pages.apply.masterDegree.contactInformationForm.form.prev': 'Back',
  'pages.apply.masterDegree.contactInformationForm.form.next': 'Next',
  'pages.apply.contactInformationForm.createContact.success': 'Create Contact successful!',
  'pages.apply.contactInformationForm.createContact.loading': 'Creating Contact...',
  'pages.apply.contactInformationForm.updateContact.success': 'Update Contact successful!',
  'pages.apply.contactInformationForm.updateContact.loading': 'Updating Contact...',
  'pages.apply.masterDegree.contactInformationForm.form.submit': 'Submit',
  'pages.apply.masterDegree.contactInformationForm.form.reset': 'Reset',
  'pages.apply.fileUploadForm.uploadFile.success': 'Upload File successful!',
  'pages.apply.fileUploadForm.uploadFile.loading': 'Uploading File...',
  'pages.apply.fileUploadForm.deleteFile.success': 'Delete File successful!',
  'pages.apply.fileUploadForm.deleteFile.loading': 'Deleting File...',
  'pages.apply.fileUploadForm.downloadFile.success': 'Download File successful!',
  'pages.apply.fileUploadForm.downloadFile.loading': 'Downloading File...',
  'pages.apply.fileUploadForm.prevSubmit': 'Previous',
  'pages.apply.fileUploadForm.nextSubmit': 'Next',
  'pages.apply.fileUploadForm.uploadFileTypeError': 'Please select a file type first.',
  'pages.apply.fileUploadForm.uploading': 'Uploading...',
  'pages.apply.fileUploadForm.download': 'Download',
  'pages.apply.fileUploadForm.uploadTitle': 'Upload File',
  'pages.apply.fileUploadForm.selectFileTypePlaceholder': 'Select File Type',
  'pages.apply.fileUploadForm.proCard.title': 'Upload File',
  'pages.apply.applicationSubmitForm.proCard.title': 'Approval',
  'pages.apply.applicationSubmitForm.warningMessage':
    'I hereby declare that all the information I have provided in the application form is complete and accurate, and I accept full responsibility for this information.',
  'pages.apply.applicationSubmitForm.checkboxMessage': 'I accept the above declaration.',
  'pages.apply.applicationSubmitForm.checkboxError': 'You must check the approval box.',
  'pages.apply.applicationSubmitForm.proCard.submit': 'Submit',
  'pages.apply.applicationSubmitForm.proCard.prev': 'Previous',
  'pages.apply.masterDegree.instituteApplyForm.yos.unit': 'Faculty to Apply',
  'pages.apply.masterDegree.instituteApplyForm.yos.unit.placeholder': 'Please select a faculty.',
  'pages.apply.masterDegree.instituteApplyForm.yos.unit2': 'Preference 2 - Faculty to Apply',
  'pages.apply.masterDegree.instituteApplyForm.yos.unit2.placeholder': 'Please select a faculty.',
  'pages.apply.masterDegree.instituteApplyForm.yos.unit3': 'Preference 3 - Faculty to Apply',
  'pages.apply.masterDegree.instituteApplyForm.yos.unit3.placeholder': 'Please select a faculty.',
  'pages.apply.masterDegree.instituteApplyForm.yos.department': 'Department to Apply',
  'pages.apply.masterDegree.instituteApplyForm.yos.department.placeholder':
    'Please select a department.',
  'pages.apply.masterDegree.instituteApplyForm.yos.department2':
    'Preference 2 - Department to Apply',
  'pages.apply.masterDegree.instituteApplyForm.yos.department2.placeholder':
    'Please select a department.',
  'pages.apply.masterDegree.instituteApplyForm.yos.department3':
    'Preference 3 - Department to Apply',
  'pages.apply.masterDegree.instituteApplyForm.yos.department3.placeholder':
    'Please select a department.',
  'pages.apply.applicationSurveyForm.firstArrivalDescription.label': 'First Arrival Description',
  'pages.apply.applicationSurveyForm.whichUniversitiesApplied.label': 'Universities Applied',
  'pages.apply.applicationSurveyForm.previousProgramDescription.label':
    'Previous Program Description',
  'pages.apply.applicationSurveyForm.isFirstApplication.label':
    'Is this your first time applying to Yeditepe University?',
  'pages.apply.applicationSurveyForm.firstApplicationDescription.label':
    'Description of First Application',
  'pages.apply.applicationSurveyForm.overseasEducationDescription.label':
    'Overseas Education Description',
  'pages.apply.applicationSurveyForm.generalInformation.label': 'General Information',
  'pages.apply.applicationSurveyForm.generalInformation.extra':
    'Please add a text of at least 200 words describing yourself and your expectations from studying at our university.',
  'pages.apply.applicationSurveyForm.throughAgency.label': 'Are you applying through an agency?',
  'pages.apply.applicationSurveyForm.whichAgency.label':
    'If applying through an agency, please provide the agency name and country.',
  'pages.apply.applicationSurveyForm.scholarship.label': 'Are you applying for a scholarship?',
  'pages.apply.applicationSurveyForm.scholarship.extra':
    'If yes, please go back to file upload and upload your letter of intent including your strengths, awards, and special talents.',
  'pages.apply.applicationSurveyForm.howDidYouHearAboutYU.label':
    'How did you hear about Yeditepe University?',
  'pages.apply.applicationSurveyForm.howDidYouHearAboutYU.option.agency': 'Agency',
  'pages.apply.applicationSurveyForm.howDidYouHearAboutYU.option.schoolCounselor':
    'School Counselor',
  'pages.apply.applicationSurveyForm.howDidYouHearAboutYU.option.friendOrRelative':
    'Friend or Relative',
  'pages.apply.applicationSurveyForm.howDidYouHearAboutYU.option.websiteOrSocialMedia':
    'Website or Social Media',
  'pages.apply.applicationSurveyForm.howDidYouHearAboutYU.option.embassyOrConsulate':
    'Embassy or Consulate',
  'pages.apply.applicationSurveyForm.howDidYouHearAboutYU.option.fair': 'Fair',
  'pages.apply.applicationSurveyForm.howDidYouHearAboutYU.option.other': 'Other',
  'pages.apply.applicationSurveyForm.yes': 'Yes',
  'pages.apply.applicationSurveyForm.no': 'No',
  'pages.apply.applicationSurveyForm.proCard.title': 'Application Survey Form',
  'pages.apply.applicationSurveyForm.proCard.next': 'Next',
  'pages.apply.applicationSurveyForm.proCard.prev': 'Previous',
  'pages.apply.applicationSurveyForm.createApplicationSurvey.success':
    'Create Application Survey successful!',
  'pages.apply.applicationSurveyForm.createApplicationSurvey.loading':
    'Creating Application Survey...',
  'pages.apply.applicationSurveyForm.updateApplicationSurvey.success':
    'Update Application Survey successful!',
  'pages.apply.applicationSurveyForm.updateApplicationSurvey.loading':
    'Updating Application Survey...',
  'pages.apply.masterDegreeForm.title': "Master's Degree Application Form",
  'pages.apply.masterDegreeForm.ribbon.existingApplication': 'EXISTING APPLICATION',
  'pages.apply.masterDegreeForm.ribbon.newApplication': 'NEW APPLICATION',
  'pages.apply.masterDegreeForm.step.generalInformation.title': 'General Information',
  'pages.apply.masterDegreeForm.step.generalInformation.description': 'Your identity information',
  'pages.apply.masterDegreeForm.step.instituteApplication.title': 'Institute Application',
  'pages.apply.masterDegreeForm.step.instituteApplication.description':
    'Selection of the institute to apply',
  'pages.apply.masterDegreeForm.step.examInformation.title': 'Exam Information',
  'pages.apply.masterDegreeForm.step.examInformation.description': 'Your exam history information',
  'pages.apply.masterDegreeForm.step.foreignLanguage.title': 'Foreign Language Information',
  'pages.apply.masterDegreeForm.step.foreignLanguage.description':
    'Your foreign language exam scores',
  'pages.apply.masterDegreeForm.step.educationInformation.title': 'Education Information',
  'pages.apply.masterDegreeForm.step.educationInformation.description':
    'Information about the schools you attended',
  'pages.apply.masterDegreeForm.step.fileUpload.title': 'Upload File',
  'pages.apply.masterDegreeForm.step.fileUpload.description': 'Passport, ID, letter, etc.',
  'pages.apply.masterDegreeForm.step.contactInformation.title': 'Contact Information',
  'pages.apply.masterDegreeForm.step.approval.title': 'Approval',
  'pages.apply.masterDegreeForm.step.approval.description': 'Approval of all steps',
  'pages.apply.internationalMasterDegreeForm.title': "International Undergraduate Application Form",
  'pages.apply.internationalMasterDegreeForm.ribbon.existingApplication': 'EXISTING APPLICATION',
  'pages.apply.internationalMasterDegreeForm.ribbon.newApplication': 'NEW APPLICATION',
  'pages.apply.internationalMasterDegreeForm.step.generalInformation.title': 'General Information',
  'pages.apply.internationalMasterDegreeForm.step.generalInformation.description':
    'Name, Surname, Nationality, ID No, Profile Photo',
  'pages.apply.internationalMasterDegreeForm.step.idInformation.title': 'Identity Information',
  'pages.apply.internationalMasterDegreeForm.step.idInformation.description':
    'Detailed identity information',
  'pages.apply.internationalMasterDegreeForm.step.instituteApplication.title':
    'Program Application',
  'pages.apply.internationalMasterDegreeForm.step.instituteApplication.description':
    'Selection of the program to apply',
  'pages.apply.internationalMasterDegreeForm.step.examInformation.title': 'Exam Information',
  'pages.apply.internationalMasterDegreeForm.step.examInformation.description':
    'Your exam history information',
  'pages.apply.internationalMasterDegreeForm.step.foreignLanguage.title':
    'Foreign Language Information',
  'pages.apply.internationalMasterDegreeForm.step.foreignLanguage.description':
    'Your foreign language exam scores',
  'pages.apply.internationalMasterDegreeForm.step.educationInformation.title':
    'Education Information',
  'pages.apply.internationalMasterDegreeForm.step.educationInformation.description':
    'Information about the schools you attended',
  'pages.apply.internationalMasterDegreeForm.step.fileUpload.title': 'Upload File',
  'pages.apply.internationalMasterDegreeForm.step.fileUpload.description':
    'Passport, ID, letter, etc.',
  'pages.apply.internationalMasterDegreeForm.step.contactInformation.title': 'Contact Information',
  'pages.apply.internationalMasterDegreeForm.step.survey.title': 'Other Information About You',
  'pages.apply.internationalMasterDegreeForm.step.approval.title': 'Approval',
  'pages.apply.internationalMasterDegreeForm.step.approval.description': 'Approval of all steps',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back to Home',
  'pages.apply.applicationDetailDescription.creationDate': 'Creation Date',
  'pages.apply.applicationDetailDescription.academicYear': 'Academic Year',
  'pages.apply.applicationDetailDescription.departmentPreference': 'Department Preference',
  'pages.apply.applicationDetailDescription.secondDepartmentPreference':
    'Second Department Preference',
  'pages.apply.applicationDetailDescription.thirdDepartmentPreference':
    'Third Department Preference',
  'pages.apply.applicationDetailDescription.majorScience': 'Major Science',
  'pages.apply.instituteApplyForm.createApplicationProgram.success':
    'Create Application Program successful!',
  'pages.apply.instituteApplyForm.createApplicationProgram.loading':
    'Creating Application Program...',
  'pages.apply.instituteApplyForm.updateApplicationProgram.success':
    'Update Application Program successful!',
  'pages.apply.instituteApplyForm.updateApplicationProgram.loading':
    'Updating Application Program...',
  'pages.apply.applicationsTable.delete': 'Delete',
  'pages.apply.applicationsTable.deleteConfirmTitle': 'Are you sure you want to delete?',
  'pages.apply.masterDegree.learningProcessForm.addLearningProcessButtonText':
    'Add Education Information',
  'pages.apply.learningProcessYosForm.highSchool.label': 'High School',
  'pages.apply.learningProcessYosForm.cgpa.label': 'CGPA',
  'pages.apply.learningProcessYosForm.gradeType.label': 'Grade Type',
  'pages.apply.learningProcessYosForm.endingAt.label': 'Ending At',
  'pages.apply.learningProcessYosForm.proCard.title': 'Learning Process',
  'pages.apply.learningProcessYosForm.proCard.next': 'Next',
  'pages.apply.learningProcessYosForm.proCard.prev': 'Previous',
  'pages.apply.learningProcessYosForm.createLearningProcessYos.success':
    'Create Learning Process YOS successful!',
  'pages.apply.learningProcessYosForm.createLearningProcessYos.loading':
    'Creating Learning Process YOS...',
  'pages.apply.learningProcessYosForm.updateLearningProcessYos.success':
    'Update Learning Process YOS successful!',
  'pages.apply.learningProcessYosForm.updateLearningProcessYos.loading':
    'Updating Learning Process YOS...',
  'pages.apply.idInformationYosForm.gender.label': 'Gender',
  'pages.apply.idInformationYosForm.passportDeadline.label': 'Passport Deadline',
  'pages.apply.idInformationYosForm.birthPlace.label': 'Birth Place',
  'pages.apply.idInformationYosForm.birthDate.label': 'Birth Date',
  'pages.apply.idInformationYosForm.motherName.label': 'Mother Name',
  'pages.apply.idInformationYosForm.fatherName.label': 'Father Name',
  'pages.apply.idInformationYosForm.maritalStatus.label': 'Marital Status',
  'pages.apply.idInformationYosForm.anyChild.label': 'Any Child',
  'pages.apply.idInformationYosForm.residenceAddress.label': 'Residence Address',
  'pages.apply.idInformationYosForm.passwordCountryOfIssue.label': 'Country of Issue for Passport',
  'pages.apply.idInformationYosForm.proCard.title': 'Identity Information Form',
  'pages.apply.idInformationYosForm.proCard.next': 'Next',
  'pages.apply.idInformationYosForm.proCard.prev': 'Previous',
  'pages.apply.idInformationYosForm.create.success': 'Create YOS Identity Information successful!',
  'pages.apply.idInformationYosForm.create.loading': 'Creating YOS Identity Information...',
  'pages.apply.idInformationYosForm.update.success': 'Update YOS Identity Information successful!',
  'pages.apply.idInformationYosForm.update.loading': 'Updating YOS Identity Information...',
  'pages.apply.idInformationYosForm.gender.male': 'Male',
  'pages.apply.idInformationYosForm.gender.female': 'Female',
  'pages.apply.idInformationYosForm.maritalStatus.married': 'Married',
  'pages.apply.idInformationYosForm.maritalStatus.single': 'Single',
  'pages.apply.idInformationYosForm.anyChild.yes': 'Yes',
  'pages.apply.idInformationYosForm.anyChild.no': 'No',
  'pages.admin.applications.downloadReportFile.success': 'Download File successful!',
  'pages.admin.applications.downloadReportFile.loading': 'Downloading File...',
  'pages.apply.masterDegree.generalInformation.upload.dragDescription':
    'Please upload the photo on your ID or Passport.',
  'pages.apply.masterDegree.generalInformation.upload.dragHintText': 'Click or drag to upload.',
  'pages.apply.masterDegree.contactInformationForm.phoneNumber.placeholder':
    'Enter your phone number (Format: +905xxxxxxxxx, only digits, max 15 characters)',
  'pages.apply.masterDegree.contactInformationForm.phoneNumber.ruleInfo':
    'Phone number must be in international format (e.g., +905xxxxxxxxx), only digits, up to 15 characters.',
  'pages.apply.masterDegree.contactInformationForm.email.placeholder': 'Enter your email address',
  'pages.apply.masterDegreeForm.educationInfoMissing.title': 'Missing Education Information',
  'pages.apply.masterDegreeForm.educationInfoMissing.description': 'You cannot proceed without adding education information.',
  'pages.apply.masterDegreeForm.fileInfoMissing.title': 'Missing File Information',
  'pages.apply.masterDegreeForm.fileInfoMissing.description': 'You cannot proceed without uploading a file.',
  'pages.apply.internationalMasterDegreeForm.fileInfoMissing.title': 'Missing File Information',
  'pages.apply.internationalMasterDegreeForm.fileInfoMissing.description': 'You cannot proceed without uploading a file.',
};
